import { render } from "./TrainingContent.vue?vue&type=template&id=7ea7949e"
import script from "./TrainingContent.vue?vue&type=script&lang=js"
export * from "./TrainingContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__